import React from "react";

interface StatusBadgeProps {
  status: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  if (status === "Deactivated") {
    return (
      <a href="#" className="badge fs-7 text-dark text-bold m-1" style={{ background: "#F6F6F6" }}>
        {status}
      </a>
    );
  }

  const isOk = status === "Ok" || status === "OK";
  return (
    <a
      href="#"
      className={`badge fs-7 ${isOk ? "badge-primary" : "badge-danger"}`}
      style={{
        color: isOk ? "#0E9F6E" : "#EE3043",
        background: isOk ? "#E8F8F4" : "#FFF5F8",
      }}
    >
      {isOk ? "OK" : "Unhealthy"}
    </a>
  );
};